import PropTypes from "prop-types";
import { Skeleton } from "@mantine/core";
import { Card, CardContent, CardHeader } from "../../ui/CustomCard/CustomCard";

export function SkeletonCard({ bannerHeight = 100, showBadge = false }) {
  return (
    <Card className="bg-white border-[#e5e7eb] shadow-none">
      <CardHeader>
        <div className="flex items-center justify-between">
          <Skeleton height={16} width={120} radius="sm" />
          {showBadge && <Skeleton height={22} width={90} radius="xl" />}
        </div>
        <Skeleton height={13} width="60%" radius="sm" className="mt-2" />
      </CardHeader>
      <CardContent>
        <Skeleton height={bannerHeight} radius="md" />
      </CardContent>
    </Card>
  );
}

export default function DeveloperPageSkeleton() {
  return (
    <div className="flex flex-col gap-6 p-4 md:p-6">
      <SkeletonCard bannerHeight={110} showBadge />
      <SkeletonCard bannerHeight={128} />
      <SkeletonCard bannerHeight={128} />
      <SkeletonCard bannerHeight={160} />
    </div>
  );
}

SkeletonCard.propTypes = {
  bannerHeight: PropTypes.number,
  showBadge: PropTypes.bool,
};
